import React from "react";
import HistoryModal from "./components/HistoryModal";
import useFlagDetails from "../useFlagDetails.logic";
import { Button, Divider, Flex, Group } from "@mantine/core";
import ExportBtn from "../../../components/exportBtn/exportBtn";
import { useNavigate, useParams } from "react-router-dom";
import FlagDetails from "./components/FlagDetails";
import AssignFlag from "./components/AssignFlag";
import Escalate from "./components/Escalate";
import Unlock from "./components/Unlock";
import AssignTo from "./components/AssignTo";
import AmlButton from "./components/AmlButton";
import FlagDetailsSkeleton from "../../../components/Skeletons/FlagDetailsSkeletons/FlagDetailsSkeleton";

const FlagDetailsActions = () => {
  const { id: idForExport } = useParams();
  const { loading } = useFlagDetails();
  const navigate = useNavigate();

  if (loading) {
    return <FlagDetailsSkeleton />;
  }

  return (
    <Flex direction="column" p="md">
      <Group bg="gray.1" mt="md" p="md" direction="row" justify="space-between">
        <ExportBtn
          exportUrl={`flag/export?flagId=${idForExport}`}
          method="POST"
          name={`flag-${idForExport}`}
        />
        <Flex aria-label="buttons" direction="row" gap="md">
          <Escalate />
          <AssignFlag />
          <Unlock />
          <AssignTo />
          <AmlButton />
          <HistoryModal />
          <Button onClick={() => navigate("/monitoring")}>Back</Button>
        </Flex>
      </Group>
      <Divider />

      <FlagDetails />
    </Flex>
  );
};

export default FlagDetailsActions;
